import ApiBase from '../../ApiBase';

class Element extends ApiBase {
    route = '/cms/elements/elements';

    /**
     * @method getSpeakerList
     * @return {Promise<*>}
     */
    async getSpeakerList() {
        return await this.get(this.route + '/speakers');
    }
}

export default new Element();
